module.exports = __webpack_public_path__ + "assets/img/recommended.b144a2cc.png";